<ng-template [ngTemplateOutlet]="template" [ngTemplateOutletContext]="context"></ng-template>
<ng-template let-formControl="formControl" let-value="value" let-openFn="openEditModeFn" #standardRead>
    <div class="read-mode d-flex align-items-center justify-content-between w-100" shdInlineEditButton="edit">
        <span class="input-text">{{ value }}</span>
    </div>
</ng-template>
<ng-template #standardWrite>
    <form class="w-100" [formGroup]="formGroup" (keydown.enter)="updateValue()"
          (keydown.escape)="reset()" shdClickOutside [active]="clickOutSideActive" (clickOutside)="reset()">
        <div class="edit-mode">
            <input
                    shdInlineEditInput
                    class="form-control inline-input h-100"
                    type="text"
                    formControlName="formControl"
                    shdAutoFocus
                    [andSelect]="true"
                    shdValidateNaming/>
        </div>
        <shd-error-field [control]="formGroup.controls['formControl']"></shd-error-field>
    </form>
</ng-template>
